import { apiFetch } from "../../core/utils/api";

async function readJsonOrThrow(res) {
  if (res.ok) {
    try {
      return await res.json();
    } catch (e) {
      return {};
    }
  }

  let text = "";
  try {
    text = await res.text();
  } catch (e) {
    text = "";
  }

  // Try to extract a decent message from JSON error bodies
  try {
    const json = text ? JSON.parse(text) : null;
    const msg =
      (json && (json.error || json.detail || json.message)) ||
      (typeof json === "string" ? json : null);
    throw new Error(msg || `Request failed (${res.status})`);
  } catch (e) {
    throw new Error(text || `Request failed (${res.status})`);
  }
}

export async function fetchWebsiteDefaultsIndex(websiteId) {
  const res = await apiFetch(`/api/websites/${websiteId}/defaults/`, {
    method: "GET",
    credentials: "include",
  });
  return readJsonOrThrow(res);
}

export async function fetchWebsiteDefaultEntry(websiteId, defaultKey) {
  const res = await apiFetch(`/api/websites/${websiteId}/defaults/${defaultKey}/`, {
    method: "GET",
    credentials: "include",
  });
  return readJsonOrThrow(res);
}

export async function patchWebsiteDefaultEntry(websiteId, defaultKey, payload) {
  const res = await apiFetch(`/api/websites/${websiteId}/defaults/${defaultKey}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload || {}),
    credentials: "include",
  });
  return readJsonOrThrow(res);
}

export async function switchWebsiteDefaultsPreset(websiteId, presetName) {
  const res = await apiFetch(`/api/websites/${websiteId}/defaults/switch-preset/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ preset_name: presetName }),
    credentials: "include",
  });
  return readJsonOrThrow(res);
}

export async function revertWebsiteDefaultsPreset(websiteId) {
  const res = await apiFetch(`/api/websites/${websiteId}/defaults/revert-preset/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
    credentials: "include",
  });
  return readJsonOrThrow(res);
}

export async function fetchDefaultsInternalElement(websiteId, elementType, elementId) {
  const res = await apiFetch(
    `/api/websites/${websiteId}/defaults/internal/${elementType}/${elementId}/`,
    { method: "GET", credentials: "include" },
  );
  return readJsonOrThrow(res);
}

export async function patchDefaultsInternalElement(websiteId, elementType, elementId, payload) {
  const res = await apiFetch(
    `/api/websites/${websiteId}/defaults/internal/${elementType}/${elementId}/`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload || {}),
      credentials: "include",
    },
  );
  return readJsonOrThrow(res);
}

